import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './app/App';
import { ApiProvider } from './hooks/useApi';
import { AuthProvider } from './hooks/useAuth';
import { ActiveRoomProvider } from './features/rooms/RoomContext';
import { ToastProvider } from './ui';
import './index.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root not found');
}

createRoot(container).render(
  <StrictMode>
    <ApiProvider>
      <AuthProvider>
        <ActiveRoomProvider>
          <ToastProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ToastProvider>
        </ActiveRoomProvider>
      </AuthProvider>
    </ApiProvider>
  </StrictMode>,
);
